import React, { useState, useEffect, useMemo } from "react";
import {
  getAllProducer,
  cleanAll,
  setBelogs,
  setDone,
} from "../../store/reducers/todosReducer";
import { toast } from "react-toastify";
import FilledLoading from "../common/loader/FilledLoading";
import OpacityLoading from "../common/loader/OpacityLoading";
import { useSelector, useDispatch } from "react-redux";
import ClientRoutes from "../../navigation/Routes";
import {
  FlexRowBetween,
  GenericDiv,
  ListHolder,
  TextWithPic,
  TodoCard,
} from "../common/Style";
import ToolsOptions from "../user/ToolsOptions";
import GenericModal from "../common/modals/GenericModal";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import tools from "../../assets/common/menu.svg";
import logout from "../../assets/common/logout.svg";
import users from "../../assets/common/usersW.svg";
import excel from "../../assets/common/excel.svg";

import whatsapp from "../../assets/common/whatsapp.svg";
import refresh from "../../assets/common/refresh.svg";
import BottomMenu from "../common/others/BottomMenu";
import Switcher from "../common/switcher/Switcher";
import { days, exportToCSV } from "../common/others/Functions";
import {
  countNotAnswered,
  getPhoneNumber,
  sendSms,
  sendWhatsapp,
} from "../../store/reducers/dataReducer";
import CopyText from "../common/others/CopyText";
import { getAllGAvivit } from "../../store/reducers/guestsReducer";

const ProducerTodos = () => {
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(false);
  const { dataLoading } = useSelector((state) => state.dataReducer);
  const { todos } = useSelector((state) => state.todosReducer);
  let history = useHistory();
  const [showLogout, setShowLogout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const handleGetAll = () => {
    setShowLoading(true);
    dispatch(getAllProducer()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setShowLoading(false);
    });
  };

  const getAllExcel = (guests) => {
    let arr = [];
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests)) {
        arr.push({
          "שם מלא": value.name,
          "מס׳ נייד": value.phone,
          קירבה: value.closeness,
          מוזמנים: value.sum,
          אישרו: value.accept === null ? "" : value.accept,
          מזמין: value.inviting,
          קשר: value.owc,
          הערות: value.notes,
        });
      }
    exportToCSV(arr, "כללי");
  };

  const handleGetGuests = (uid) => {
    setShowLoading(true);

    dispatch(getAllGAvivit(uid)).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else getAllExcel(res.payload);
      setShowLoading(false);
    });
  };

  const handleCountNotAnswered = (uid) => {
    setShowLoading(true);
    dispatch(countNotAnswered({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            {res.payload.isReadyAdmin ? (
              <div style={{ width: "30%" }}>האירוע מוכן</div>
            ) : (
              <>
                <div>{res.payload.waze.length ? "✔️" : "❌"}</div>
                <div>{res.payload.amount}</div>
                <img
                  src={excel}
                  style={{ width: "25px" }}
                  onClick={() => {
                    if (res.payload.eventType) handleGetGuests(uid);
                    else
                      toast.info(
                        "לא מדובר בחתונה ולכן אין אפשרות למזמין + קשר"
                      );
                  }}
                />
              </>
            )}
            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={res.payload.phone}
            />
          </FlexRowBetween>
        );
      setShowLoading(false);
    });
  };

  const handleGetIsPaid = (uid) => {
    setShowLoading(true);
    dispatch(getPhoneNumber({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <div>{res.payload.isPaid ? "שולם" : "לא שולם"}</div>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/972${res.payload.phone}/?text=לקוח יקר זו הודעה אוטומטית. תהליך וידוא ההגעה הסתיים ועליך להסדיר תשלום. לשם כך יש להיכנס למערכת, תפריט, לו״ז, לבחור ב״הסדרת תשלום״ ולעקוב אחר ההוראות`}
            >
              <img src={whatsapp} alt={"whatsapp"} style={{ width: "31px" }} />
            </a>
            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={res.payload.phone}
            />
          </FlexRowBetween>
        );
      setShowLoading(false);
    });
  };

  const handleCheck1 = (uid) => {
    setShowLoading(true);
    dispatch(getPhoneNumber({ uid })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else
        toast.info(
          <FlexRowBetween>
            <a
              target="_blank"
              rel="noreferrer"
              href={`https://wa.me/972${res.payload.phone}/?text=לקוח יקר, אנא כנס למערכת, תפריט, לו״ז, ולחץ על המשימה שיש להיום ופעל בהתאם`}
            >
              <img src={whatsapp} alt={"whatsapp"} style={{ width: "31px" }} />
            </a>
            <CopyText
              marginLeft={"5px"}
              dataToCopy={res.payload.phone}
              text={res.payload.phone}
            />
          </FlexRowBetween>
        );
      setShowLoading(false);
    });
  };

  const handleSetDone = async (id, done) => {
    const body = { done };
    dispatch(setDone(id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleSetBelogs = async (id, belongs) => {
    const body = { belongs };
    dispatch(setBelogs(id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  useEffect(() => {
    handleGetAll();
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  let todosArray = useMemo(() => {
    let arr = [];
    let sortedArray = [];
    if (Object.keys(todos).length > 0) {
      for (const [key, value] of Object.entries(todos)) sortedArray.push(value);
      sortedArray.sort(
        (a, b) => new Date(a["executionDate"]) - new Date(b["executionDate"])
      );
      for (let i = 0; i < sortedArray.length; i++)
        arr.push(
          <TodoCard
            borderL={
              sortedArray[i].company == "besimple"
                ? "rgba(177, 141, 224, 0.9)"
                : "none"
            }
            style={{
              borderRight:
                days(new Date(), new Date(sortedArray[i].executionDate)) == 0
                  ? "5px solid #7b96c4"
                  : "none",
              cursor: "text",
            }}
            key={i}
          >
            <div onClick={() => handleCountNotAnswered(sortedArray[i].uid)}>
              {sortedArray[i].title}
            </div>
            <div style={{ fontSize: "13px" }}>
              {sortedArray[i].executionDate
                .replace(/T.*/, "")
                .split("-")
                .reverse()
                .join("/")}
            </div>

            {/* {sortedArray[i].title.split(" ")[0] === "הסדרת" && (
              <GenericDiv
                onClick={() => handleGetIsPaid(sortedArray[i].uid)}
                background={"rgba(123,150,196,0.95)"}
                style={{ margin: "0 20px", padding: "4px 4px" }}
              >
                בדיקה
              </GenericDiv>
            )} */}

            {(sortedArray[i].title.split(" ")[0] === "לבדוק" ||
              sortedArray[i].title.split(" ")[0] === "לוודא") && (
              <GenericDiv
                onClick={() => handleCheck1(sortedArray[i].uid)}
                background={"rgba(123,150,196,0.95)"}
                style={{ margin: "0 20px", padding: "4px 4px" }}
              >
                בדיקה
              </GenericDiv>
            )}

            <div
              style={{ width: "min-content" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Switcher
                onOfColor={"#C0C0C0"}
                color={"#7b96c4"}
                checked={
                  sortedArray[i].title.split(" ")[0] === "שיחה"
                    ? sortedArray[i].belongs
                    : sortedArray[i].done
                }
                onChange={() => {
                  if (sortedArray[i].title.split(" ")[0] === "שיחה")
                    handleSetBelogs(
                      sortedArray[i]._id,
                      !sortedArray[i].belongs
                    );
                  else handleSetDone(sortedArray[i]._id, !sortedArray[i].done);
                }}
              />
            </div>
          </TodoCard>
        );
    }
    return arr;
  }, [todos]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={1}
            src={refresh}
            alt="refresh"
            style={{ width: "23px", padding: "10px 0", cursor: "pointer" }}
            onClick={handleGetAll}
          />,
          <img
            key={1}
            src={users}
            alt="users"
            style={{ width: "28px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => history.push(ClientRoutes.Producer.main)}
          />,
          <img
            key={3}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <ListHolder>{todosArray}</ListHolder>
      <div style={{ height: "100px" }} />

      {showLoading && <FilledLoading />}
      {dataLoading && <OpacityLoading />}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.Admin.main)}
                >
                  ראשי
                </TextWithPic>,
                // <TextWithPic
                //   onClick={() => history.push(ClientRoutes.Admin.todos)}
                //   key={2}
                // >
                //   משימות
                // </TextWithPic>,
              ]}
            />
          }
        />
      )}
    </div>
  );
};

export default ProducerTodos;
